// emitter.ts
import mitt, { Emitter } from "mitt";
interface Message {
  message: string;
  right: boolean;
}

// map each event name to the type of its payload
type Events = {
  onHistoryUpdate: Message[];
  onSend: any;
  onUpdatingMessage: boolean;
  onUpdateSubscriptionModal: boolean;
  toggleReaderMode: boolean;
  upgradePopup: string;

  // …you can add more events here, e.g.
  // userLoggedIn: { userId: string };
};

// create a typed emitter
export const emitter: Emitter<Events> = mitt<Events>();
